(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var init = function(){
    var els = document.querySelectorAll('main .shopify-section');
    if (!('IntersectionObserver' in window) || !els.length) return;
    els.forEach(function(el, i){ if (i > 0) el.classList.add('utz-reveal'); });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('utz-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function(el){ io.observe(el); });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
